import React from 'react'
import { toast } from 'react-toastify'
import MaterialSymbol from '../components/MaterialSymbol'
import { Capacitor } from '@capacitor/core'
import { Clipboard } from '@capacitor/clipboard'

export const onClickDeveloper = () => {
  if (Capacitor.isNativePlatform()) {
    Clipboard.read().then(({ type, value }) => {
      console.log(`Got ${type} from clipboard: ${value}`)
      const data = JSON.parse(value)
      Object.keys(data).forEach((k) => {
        localStorage.setItem(k, data[k])
      })

      toast('Details copied to auth', {
        type: 'success',
        icon: <MaterialSymbol>inventory</MaterialSymbol>,
      })

      // eslint-disable-next-line no-self-assign
      window.location = window.location
    })
  }
}

export default onClickDeveloper
